import withLazyLoad from "../lib/withLazyLoad";
import { ProductsCarouselWithData } from "../ProductsCarouselWithData";

export const LazyLoadProductsCarouselWithData = withLazyLoad(
  ProductsCarouselWithData,
);
